import React, { Component } from 'react';
import SDate from "./sdate.js";

export class Tasks extends Component {
  componentDidMount = this.refresh;

  state = { 
    fields: [],
    rows: [],
    tableView: [], 
    page: 1
  }
  

  async componentWillReceiveProps(p) {
    if(this.props.activity !== p.activity || this.props.data !== p.data) {
      this.setState({
        fields: p.data.fields,
        rows: p.activity === null ? [] : (p.data.data || [])
      })
    }
  }

  getTD(fields, row) {
    return fields.filter(f=> f.visible).map((f,i) => {
      let txt = row[f.field];

      if(txt) {
        f.type === "d" && (txt = txt ? SDate(txt).aFormat : "-");
        f.type === "b" && (txt = txt ? "Ano" : "Ne");

        if(f.type === "e" && f.enum && txt) {
          const enm = f.enum.find(f => f.key == txt);
          txt = (enm || {}).disp;
        }
      }

      return (<td className={"field " + f.type + " " + f.field} key={i}>{String(txt || "-")}</td>);
    })
  }

  getRows(fields, data) {
    return data.map((tr,i) => (
      <tr key={i}>
        { this.getTD(fields, tr) }
      </tr>
    ))
  }

  render() {
    let fields = this.state.fields;
    let rows = this.state.rows;
  
    if(!fields || !rows) return [];

    let recordsTo = (this.max > this.records) ? (this.records) : (+this.max + +this.min);
    let recordsFrom = this.min + 1;
    recordsFrom = (+recordsFrom > +recordsTo) ? recordsTo : recordsFrom;

    return (
      <div className="dataTables_wrapper dt-bootstrap no-footer" style={{display: rows.length ? "block" : "none"}}>
        {/*
        <div className="flex">
          <div className="dataTables_length col-sm-6">
            <label>Zobrazit <select name="demands_length" aria-controls="demands" className="form-control input-sm m-wrap small" onInput={e => this.setFilter(e.target.value)}>
                <option value="2">2</option>
                <option value="5">5</option>
                <option value="10" selected>10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select> záznamů</label>
          </div>
          <div className="dataTables_info">
            Zobrazeno {recordsFrom} do {rows.length} z {rows.length} záznamů
          </div>
          <div className="dataTables_paginate paging_simple_numbers">
            <ul className="pagination">
              <li className="paginate_button prev" onClick={() => this.setPage(--this.state.page)}><a>Předchozí</a></li>
                {this.getPages(this.state.page, Math.ceil(this.records / this.max))}  
              <li className="paginate_button next" onClick={() => this.setPage(++this.state.page)}><a>Další</a></li>
            </ul>
          </div>
          <div className="dataTables_filter">
            <label>
              <input type="search" className="form-control input-sm" placeholder="Hledat" value={this.state.searchText} onInput={this.search} />
                <button type="button" className="btn btn-orange btn-sm searchclrbtn" onClick={this.searchClear}><i className="fa fa-times"></i></button>
            </label>
          </div>
        </div>
        */}
        <table className="table table-striped display responsive table-bordered table-hover dataTable no-footer dtr-inline" id="tasks">
          <thead>
            <tr role="row">
              {fields.filter(f=> f.visible).map(f => <th className="sorting">{f.caption}</th>)}
            </tr>
          </thead>
          <tbody>
            {this.getRows(fields, rows)}
          </tbody>
        </table>
      </div>
    )
  }
}